import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PrimaryButton } from 'jl-design-system/elements/button/Button';
import Link from 'jl-design-system/elements/link/Link';
import reload from 'jl-design-system/utils/reload/reload';
import styles from './generic-error.scss';

export class GenericError extends Component {
  static propTypes = {
    basketUrl: PropTypes.string,
  };

  static defaultProps = {
    basketUrl: '',
  };

  render() {
    const { basketUrl } = this.props;

    return (
      <div className={styles.container}>
        <h1 className={styles.title} data-test="generic-error-title">
          Sorry, something went wrong
        </h1>
        <p className={styles.bodyupper} data-test="generic-error-text">
          We are currently experiencing technical problems and your order hasn&apos;t been placed yet.
          Please reload checkout and try again, or return to your basket if the problem persists.
        </p>
        <PrimaryButton
          className={styles.button}
          onClick={reload}
        >
          Reload checkout
        </PrimaryButton>
        <Link
          className={styles.link}
          data-action="handback"
          to={basketUrl}
        >
          Go to your basket
        </Link>
      </div>
    );
  }
}

export default connect(state => ({
  basketUrl: state.bff.basketUrl,
}))(GenericError);
